export default {
  block: {
    producerSchedule: {
      title: "Block Producers Schedule"
    },
    dpos_lib_num: "DPoS LIB Num",
    scheduleVersion: "Schedule version",
    transactionCount: "Tx Count",
    irreversible: "Irreversible",
    stale: "Stale",
    reversible: "Reversible",
    title: "Blocks",
    newBlock: "{{count}} new block",
    newBlock_plural: "{{count}} new blocks",
    list: {
      title: "Blocks",
      empty: "No blocks",
      loading: "Loading blocks...",
      header: {
        timestamp: "Timestamp",
        block_num: "Block #",
        id: "Block ID",
        age: "Age",
        producer: "Producer",
        transactionCount: "Tx Count",
        productionTimeElapsed: "Production Time (s)"
      }
    }
  }
}
